import _ from 'lodash';

import { createApiReducer } from 'src/api';

import {
  ADD_PERSON_START,
  ADD_PERSON_SUCCESS,
  ADD_PERSON_FAILURE,
  UPDATE_PERSON_START,
  UPDATE_PERSON_SUCCESS,
  UPDATE_PERSON_FAILURE,
  DELETE_PERSON_START,
  DELETE_PERSON_SUCCESS,
  DELETE_PERSON_FAILURE,
  ADD_PERSON_BADGE_START,
  ADD_PERSON_BADGE_SUCCESS,
  ADD_PERSON_BADGE_FAILURE,
  UPDATE_PERSON_BADGE_START,
  UPDATE_PERSON_BADGE_SUCCESS,
  UPDATE_PERSON_BADGE_FAILURE,
  SET_PERSON_BADGE_IMAGES_START,
  SET_PERSON_BADGE_IMAGES_SUCCESS,
  SET_PERSON_BADGE_IMAGES_FAILURE,
  DELETE_PERSON_BADGE_START,
  DELETE_PERSON_BADGE_SUCCESS,
  DELETE_PERSON_BADGE_FAILURE,
  FETCH_PEOPLE_START,
  FETCH_PEOPLE_SUCCESS,
  FETCH_PEOPLE_FAILURE,
  SET_PERSON_LICENSE_IMAGES_START,
  SET_PERSON_LICENSE_IMAGES_SUCCESS,
  SET_PERSON_LICENSE_IMAGES_FAILURE,
  FETCH_ACCOUNT_AGENTS_START,
  FETCH_ACCOUNT_AGENTS_SUCCESS,
  FETCH_ACCOUNT_AGENTS_FAILURE,
} from './actions';
const transformInsurance = response => {
  return {
    coverage: response.insurance_information_coverage_type,
    lastSubmit: response.insurance_information_last_submitted,
    insuranceInformationMarkedComplete:
      response.insurance_information_marked_complete,
    groupName: response.insurance_information_group_name
      ? response.insurance_information_group_name.insurance_group_name
      : null,
    familyMembers: response.insurance_information_family_member?.map(
      member => ({
        firstName: member.insurance_family_member_first_name,
        lastName: member.insurance_family_member_last_name,
        relationship: member.insurance_family_member_relationship,
        gender: member.insurance_family_member_gender,
        dob: member.insurance_family_member_dob,
        id: member.id,
      })
    ),
  };
};
/* eslint-disable func-names */
const transformBadge = response => ({
  id: response.id,
  locationId: response.badge_location,
  badgeDateExpired: response.badge_date_expired,
  badgeImageBack: response.badge_image_back,
  badgeImageFront: response.badge_image_front,
  badgeNumber: response.badge_number,
});

export const transformPerson = (response, primaryAgents, secondaryAgents) => {
  let agentRole = null;
  if (primaryAgents?.length) {
    if (primaryAgents.includes(response.id)) {
      agentRole = 'Primary Agent';
    }
  }
  if (secondaryAgents?.length) {
    if (secondaryAgents.includes(response.id)) {
      agentRole = 'Secondary Agent';
    }
  }
  const userRole =
    _.get(response, 'user_role') ||
    _.get(
      response,
      'user_user_financial_institutions[0].user_financial_institution_role'
    ) ||
    _.get(response, 'user_user_accounts[0].user_account_role') ||
    {};

  const roleId = userRole.id;
  const roleName = userRole.user_role_role;
  return {
    id: response.id,
    roleId,
    roleName,
    agentRole,
    citizenship: response.user_citizenship,
    dob: response.user_dob,
    emailAddress: response.user_email_address,
    firstName: response.user_first_name,
    flag: response.user_flag,
    initiatedDate: response.user_initiated_date,
    lastName: response.user_last_name,
    licenseTypeId: response.user_license_type,
    licenseExpirationDate: response.user_license_expiration_date,
    licenseIssuedDate: response.user_license_issued_date,
    licenseIssuingState: response.user_license_issuing_state,
    licenseNumber: response.user_license_number,
    licenseImageFront: response.user_license_image_front,
    licenseImageBack: response.user_license_image_back,
    mailingAddress: response.user_mailing_address,
    mailingAddress2: response.user_mailing_address_2,
    mailingCity: response.user_mailing_city,
    mailingState: response.user_mailing_state,
    mailingZipcode: response.user_mailing_zipcode,
    military: response.user_military,
    occupation: response.user_occupation,
    otherNumber: response.user_other_number,
    primaryAddress: response.user_primary_address,
    primaryAddress2: response.user_primary_address_2,
    primaryCity: response.user_primary_city,
    primaryNumber: response.user_primary_number,
    primaryState: response.user_primary_state,
    primaryZipcode: response.user_primary_zipcode,
    socialSecurity: response.user_ssn,
    updatedDate: response.user_updated_date,
    verification: response.user_verification,
    bgReport: response.user_background_report,
    bgStatus: response.user_background_check_status,
    gender: response.user_gender,
    insuranceInformation: response.user_insurance_information
      ? transformInsurance(response.user_insurance_information)
      : {},

    name: `${response.user_first_name} ${response.user_last_name}`,

    title: _.get(response, 'user_user_accounts[0].user_account_title'),
    type: _.get(response, 'user_user_accounts[0].user_account_type'),
    status: _.get(response, 'user_user_accounts[0].user_account_status'),
    allowedReports: _.get(
      response,
      'user_user_accounts[0].user_account_allowed_reports'
    ),
    isAdmin: _.get(response, 'user_user_accounts[0].user_account_is_admin'),
    isSigner: _.get(response, 'user_user_accounts[0].user_account_is_signer'),
    isNdaSigned: _.get(
      response,
      'user_user_financial_institutions[0].user_financial_institution_nda_signed'
    ),
    receiveExpirationNotification: _.get(
      response,
      'user_user_financial_institutions[0].user_financial_institution_receive_expiration_notifications'
    ),
    expirationNotificationFrequency: _.get(
      response,
      'user_user_financial_institutions[0].user_financial_institution_expiration_notification_frequency'
    ),
    notifyOnDocumentUpload: _.get(
      response,
      'user_user_financial_institutions[0].user_financial_institution_notify_on_document_upload'
    ),
    nda: _.get(
      response,
      'user_user_financial_institutions[0].user_financial_institution_nda'
    ),
    isBgConsentSigned: _.get(
      response,
      'user_user_financial_institutions[0].user_financial_institution_bg_consent_signed'
    ),
    bgConsent: _.get(
      response,
      'user_user_financial_institutions[0].user_financial_institution_bg_consent'
    ),

    percentageOwnership: _.get(
      response,
      'user_user_accounts[0].user_account_percentage_ownership'
    ),
    badges: _.get(
      response,
      'user_user_accounts[0].user_account_badges',
      []
    ).map(transformBadge),
  };
};

// the response lists every account the person belongs to, in no particular
// order; the account's own people are described by their membership of it
const transformAccountPerson = (response, accountId) => {
  const membership = _.find(
    response.user_user_accounts,
    userAccount => _.get(userAccount, 'user_account_account.id') === accountId
  );
  return transformPerson(
    membership ? { ...response, user_user_accounts: [membership] } : response
  );
};

const accountFetchPeopleReducer = createApiReducer(
  [FETCH_PEOPLE_START, FETCH_PEOPLE_SUCCESS, FETCH_PEOPLE_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      people: payload.map(person =>
        transformAccountPerson(person, state.data.id)
      ),
    };
  },
  error => _.get(error, 'payload')
);

const updateItem = (list, key, value, newItem) => {
  return list.map(item => {
    if (item[key] === value) {
      return newItem;
    }
    return item;
  });
};

const transformAccountAgents = (response, primaryAgents, secondaryAgents) => {
  let agentRole = null;

  if (primaryAgents.includes(response.id)) {
    agentRole = 'Primary Agent';
  }
  if (secondaryAgents.includes(response.id)) {
    agentRole = 'Secondary Agent';
  }

  return {
    agentRole,
    firstName: response.user_first_name,
    lastName: response.user_last_name,
  };
};
const accountAddPersonReducer = createApiReducer(
  [ADD_PERSON_START, ADD_PERSON_SUCCESS, ADD_PERSON_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      people: [
        ...state.data.people,
        transformAccountPerson(payload, state.data.id),
      ],
    };
  },
  error => transformPerson(_.get(error, 'payload.response', {}))
);

const accountUpdatePersonReducer = createApiReducer(
  [UPDATE_PERSON_START, UPDATE_PERSON_SUCCESS, UPDATE_PERSON_FAILURE],
  (payload, state) => {
    const newPerson = transformAccountPerson(payload, state.data.id);
    return {
      ...state.data,
      people: updateItem(state.data.people, 'id', newPerson.id, newPerson),
    };
  },
  error => {
    const response = _.get(error, 'payload.response') || {};
    return { ...transformPerson(response), detail: response.detail };
  }
);

const accountSetPersonLicenseImagesReducer = createApiReducer(
  [
    SET_PERSON_LICENSE_IMAGES_START,
    SET_PERSON_LICENSE_IMAGES_SUCCESS,
    SET_PERSON_LICENSE_IMAGES_FAILURE,
  ],
  (payload, state) => {
    const newPerson = transformAccountPerson(payload, state.data.id);

    return {
      ...state.data,
      people: updateItem(state.data.people, 'id', newPerson.id, newPerson),
    };
  },
  error => transformPerson(_.get(error, 'payload.response', {}))
);

const accountDeletePersonReducer = createApiReducer(
  [DELETE_PERSON_START, DELETE_PERSON_SUCCESS, DELETE_PERSON_FAILURE],
  (payload, state) => {
    // the archive endpoint responds with the UserAccount row, whose own id is
    // unrelated to the user ids that `people` is keyed by
    return {
      ...state.data,
      people: state.data.people.filter(p => p.id !== payload.user_account_user),
    };
  },
  error => {
    const response = _.get(error, 'payload.response') || {};
    return { ...transformPerson(response), detail: response.detail };
  }
);

const accountAddPersonBadgeReducer = createApiReducer(
  [ADD_PERSON_BADGE_START, ADD_PERSON_BADGE_SUCCESS, ADD_PERSON_BADGE_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      people: state.data.people.map(p => ({
        ...p,
        badges:
          p.id === payload.user_id
            ? [...p.badges, transformBadge(payload)]
            : p.badges,
      })),
    };
  },
  error => transformBadge(_.get(error, 'payload.response', {}))
);

const updateBadges = (payload, state) => {
  const newBadge = transformBadge(payload);

  return {
    ...state.data,
    people: state.data.people.map(p => ({
      ...p,
      badges: updateItem(p.badges, 'id', newBadge.id, newBadge),
    })),
  };
};

const accountUpdatePersonBadgeReducer = createApiReducer(
  [
    UPDATE_PERSON_BADGE_START,
    UPDATE_PERSON_BADGE_SUCCESS,
    UPDATE_PERSON_BADGE_FAILURE,
  ],
  updateBadges,
  error => transformBadge(_.get(error, 'payload.response', {}))
);

const accountSetPersonBadgeImageReducer = createApiReducer(
  [
    SET_PERSON_BADGE_IMAGES_START,
    SET_PERSON_BADGE_IMAGES_SUCCESS,
    SET_PERSON_BADGE_IMAGES_FAILURE,
  ],
  updateBadges,
  error => transformBadge(_.get(error, 'payload.response', {}))
);

const accountDeletePersonBadgeReducer = createApiReducer(
  [
    DELETE_PERSON_BADGE_START,
    DELETE_PERSON_BADGE_SUCCESS,
    DELETE_PERSON_BADGE_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      people: state.data.people.map(p => ({
        ...p,
        badges: p.badges.filter(b => b.id !== payload.id),
      })),
    };
  },
  error => transformBadge(_.get(error, 'payload.response', {}))
);
const accountFetchAgentsReducer = createApiReducer(
  [
    FETCH_ACCOUNT_AGENTS_START,
    FETCH_ACCOUNT_AGENTS_SUCCESS,
    FETCH_ACCOUNT_AGENTS_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      primaryAgents: payload.account_primary_agents,
      secondaryAgents: payload.account_secondary_agents,
      accountAgents: payload.account_users.map(function(x) {
        return transformAccountAgents(
          x,
          payload.account_primary_agents,
          payload.account_secondary_agents
        );
      }),
    };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);
export const reducers = [
  accountAddPersonReducer,
  accountUpdatePersonReducer,
  accountDeletePersonReducer,
  accountAddPersonBadgeReducer,
  accountUpdatePersonBadgeReducer,
  accountSetPersonBadgeImageReducer,
  accountDeletePersonBadgeReducer,
  accountFetchPeopleReducer,
  accountSetPersonLicenseImagesReducer,
  accountFetchAgentsReducer,
];
